// import { ucFirst } from "../helper.utils"
import { ETA_DAYS } from "../constants"
const settingMetals = {
    'white-gold-engagement-rings': '14KtWhiteGold',
    'yellow-gold-engagement-rings': '14KtYellowGold',
    'rose-gold-engagement-rings': '14KtRoseGold',
    'platinum-engagement-rings': 'Platinum',
}

const styles = [
    'solitaire-engagement-rings',
    'three-stone-engagement-rings',
    'side-stone-engagement-rings',
    'halo-engagement-rings',
    'vintage-engagement-rings',
    'hidden-halo-engagement-rings'
]

const cyoLooseShape = ['round-rings', 'pear-rings', 'oval-rings', 'emerald-rings', 'cushion-rings', 'princess-rings', 'radiant-rings', 'heart-rings', 'asscher-rings', 'marquise-rings']

const looseShape = ['round-cut-diamond', 'pear-cut-diamond', 'oval-cut-diamond', 'emerald-cut-diamond', 'cushion-cut-diamond', 'princess-cut-diamond', 'radiant-cut-diamond', 'heart-cut-diamond', 'asscher-cut-diamond', 'marquise-cut-diamond']

const labs = ['gia-certified', 'igi-certified']

export function isActive(filter, option, debug = false) {

    // check if the option is in the query filter
    const route = useRoute()
    const filterQueryKey = route.query[filter.value.urlLabel]

    // check if filter exists in the query
    if (filterQueryKey && option && typeof filterQueryKey === 'string') {

        const queryArray = filterQueryKey.split(',').map(item => item.trim().toLowerCase())
        const match = queryArray.some(query => {
            const url = option.url ? option.url.toLowerCase() : '';
            return query == url;
        });
        return match
    }

    const hasFilterInRoute = testRouteParam(filter, option, debug)
    return hasFilterInRoute
}

export function testRouteParam(filter, option, debug = false) {

    const route = useRoute()

    // check if filter exists in route params
    const start_with = route.params.start_with
    if (filter.value.name === 'shape') {

        // cyo loose shape
        if (cyoLooseShape.includes(start_with)) {
            const normalizedUrlKey = start_with.replace('-rings', '').split('-').join('_')
            return normalizedUrlKey === option.url.toLowerCase()
        }
        // loose shape
        else if (looseShape.includes(start_with)) {

            const normalizedUrlKey = start_with.replace('-cut-diamond', '').split('-').join('_')
            return normalizedUrlKey === option.url.toLowerCase()
        }
    }

    // check if start with is with style 
    if (filter.value.name === 'style') {

        const normalizedUrlKey = start_with?.replace('-engagement-rings', '').toLowerCase()
        return option.url.toLowerCase() === normalizedUrlKey
    }

    // check if start with is with metal
    if (filter.value.name === 'metal' && Object.keys(settingMetals).includes(start_with)) {
        return settingMetals[start_with] === option.url
    }

    // check if start with is with lab
    if (filter.value.name === 'report' && labs.includes(start_with)) {
        return start_with.replace('-certified', '').toUpperCase() === option.url.toUpperCase()
    }
    // console.log(route.meta.moduleSubType, filter.value.name, 'route.meta.moduleSubType')
    if( filter.value.name === 'shipdate' && route.meta.moduleSubType === 'in-stock-ring'){
        return ETA_DAYS === option.value
    }
}

export function checkStartWithPayload ( payload, start_with, route ){
    
    const giftKeys = ['gifts-under-1000', 'gifts-under-2000', 'gifts-under-3000', 'gifts-under-50000', 'gifts-under-80000', 'gifts-under-100000']

    if (!start_with || typeof start_with !== 'string') {
        return payload
    }

    // start with metal
    if (Object.keys(settingMetals).includes(start_with)) {

        return { Metal: settingMetals[start_with] }
    }

    else if(styles.includes(start_with)) {

        const key = ucWords(start_with.replace('-engagement-rings', ''))
        return { Style: key }
    }

    else if(cyoLooseShape.includes(start_with)) {

        const key = ucFirst(start_with.replace('-rings', ''))
        return { Shape: key }
    }
    // loose shape
    else if (looseShape.includes(start_with)) {

        const key = ucFirst(start_with.replace('-cut-diamond', ''))
        return { Shape: key }
    }

    else if (labs.includes(start_with)) {

        const key = ucFirst(start_with.replace('-certified', ''))
        return { Report: key.toUpperCase() }
    }
    else if(giftKeys.includes(start_with) && !route.query.PriceFrom){

        return {
            PriceFrom: 1,
            PriceTo: start_with.replace('gifts-under-', '')
        }
    } 
    return payload
}


export function setFilterFromRouteParam(filters, options, router) {

    const payload = {}
    const start_with = router.currentRoute.value.params.start_with
    const route = router.currentRoute.value

    const inStockKeys = ['in-stock-ring', 'in-stock-earring', 'in-stock-pendant']
    const engagementRingsBudgetKeys = ['2000-engagement-rings', '3000-engagement-rings', '5000-engagement-rings', '10000-engagement-rings']

    if (typeof start_with === 'string') {
        return checkStartWithPayload(payload, start_with, route)
    }
    
    // start with metal
    if(inStockKeys.includes(route.meta.moduleSubType) && !route.query.Shipdate){

        return {
            Shipdate: `${ETA_DAYS}_days`,
        }
    }else if( engagementRingsBudgetKeys.includes(route.meta.moduleSubType) && !route.query.PriceFrom ){
        const budget = Number(route.meta.moduleSubType.replace('-engagement-rings', ''))
        return {
            PriceFrom: budget - 200,
            PriceTo: budget + 200,
        }
    }

    return payload

}


export function setDefaultFilters(modPayload, caratMax) {

    if( !modPayload?.CaratFrom){
        modPayload.CaratFrom = 1
        modPayload.CaratTo = caratMax
    }

    if( !modPayload?.Clarity){
        modPayload.Clarity = ['VS1', 'VVS2', 'VVS1', 'IF', 'FL']
    }
    if( !modPayload?.Color){
        modPayload.Color = ['F', 'E', 'D']
    }
    if( !modPayload?.Cut){
        modPayload.Cut = ['EX', 'ID']
    }
    return modPayload
}